import React from 'react'
import PropTypes from 'prop-types'
import {
  IconFAWrapper,
  ICON_FA_VARIANT_SOLID,
  ICON_FA_VARIANT_REGULAR,
  ICON_FA_VARIANT_LIGHT
} from './IconFAWrapper'

export const IconFAChevronLeft = ({
  className,
  variant,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconFAWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      {variant === ICON_FA_VARIANT_SOLID ? (
        <svg
          aria-hidden='true'
          focusable='false'
          data-prefix='fas'
          data-icon='chevron-left'
          role='img'
          viewBox='0 0 320 512'
        >
          <path
            shapeRendering='geometricPrecision'
            fill='currentColor'
            d='M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z'
          />
        </svg>
      ) : variant === ICON_FA_VARIANT_REGULAR ? (
        <svg
          aria-hidden='true'
          focusable='false'
          data-prefix='far'
          data-icon='chevron-left'
          role='img'
          viewBox='0 0 256 512'
        >
          <path
            shapeRendering='geometricPrecision'
            fill='currentColor'
            d='M231.293 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L70.393 256 251.092 74.87c4.686-4.686 4.686-12.284 0-16.971L231.293 38.1c-4.686-4.686-12.284-4.686-16.971 0L4.908 247.515c-4.686 4.686-4.686 12.284 0 16.971L214.322 473.9c4.687 4.686 12.285 4.686 16.971-.001z'
          />
        </svg>
      ) : (
        <svg
          aria-hidden='true'
          focusable='false'
          data-prefix='fal'
          data-icon='chevron-left'
          role='img'
          viewBox='0 0 256 512'
        >
          <path
            shapeRendering='geometricPrecision'
            fill='currentColor'
            d='M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z'
          />
        </svg>
      )}
    </IconFAWrapper>
  )
}

IconFAChevronLeft.defaultProps = {
  variant: ICON_FA_VARIANT_REGULAR
}

IconFAChevronLeft.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf([
    ICON_FA_VARIANT_SOLID,
    ICON_FA_VARIANT_REGULAR,
    ICON_FA_VARIANT_LIGHT
  ]),
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
